import React, { useRef, useState, useCallback } from 'react';
import { Popover, Icon, Tappable } from '@vectord/components';
import { useOutsideClick } from '@vectord/hooks';

import EditNotePopoverSection from '../EditNotePopoverSection';
import Field from 'components/Field';
import styles from './CoursePauseNotePopover.module.scss';

const placementsMap = {
  left: { top: '-500%', right: '70%' },
};

function CoursePauseNotePopover({ request }) {
  const popoverRef = useRef(null);
  const noteRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { note } = request;

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleOutsideClick = useCallback(
    (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        handleClose();
      }
    },
    [handleClose]
  );

  const handleNoteClick = useCallback(() => {
    setIsOpen(true);
  }, []);

  useOutsideClick(noteRef, handleOutsideClick);

  return (
    <>
      <Tappable
        noHighlight
        ref={noteRef}
        className={styles.note}
        onClick={handleNoteClick}
      >
        <div className={styles.noteContainer}>{note?.content || 'N/A'}</div>
      </Tappable>
      <Popover
        ref={popoverRef}
        anchorRef={noteRef}
        isOpen={isOpen}
        location={placementsMap['left']}
        onClose={handleClose}
      >
        <div className={styles.popoverContent}>
          <Icon
            name="clear"
            className={styles.closeIcon}
            onClick={handleClose}
          />
          <Field
            label="Note"
            className="h5"
          >
            <EditNotePopoverSection
              handleClose={handleClose}
              coursePauseRequest={request}
            />
          </Field>
        </div>
      </Popover>
    </>
  );
}

export default CoursePauseNotePopover;
